import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PaymentCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/checkout");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="payment-cancel">
      <h1>Payment Cancelled</h1>
      <p>Your payment was cancelled. Redirecting back to checkout...</p>
    </div>
  );
};

export default PaymentCancel;
